"use client";
import Image from "next/image";
import Container from "../ui/container";

export default function NightOperationsSection() {
  return (
    <div className='relative overflow-hidden py-12 md:py-24 bg-black'>
      <Container className='relative'>
        <div className='grid grid-cols-1 md:grid-cols-2 gap-4 items-center px-4'>
          {/* Text Content */}
          <div className='w-full flex flex-col gap-4 md:gap-8 order-1 md:order-1 md:pr-8 z-10'>
            <h2 className='text-4xl font-bold'>
              <span className='text-primary'>Low-Lighting</span> Operations with
              Backlit Technology
            </h2>
            <p className='text-lg text-muted-foreground'>
              Our backlit mine vehicle identification solutions ensure vehicles
              remain visible and easily identifiable even in low-light or night
              conditions. The illuminated signage enhances safety and
              operational efficiency, allowing crews to quickly recognize
              vehicles at any hour.
            </p>
          </div>
          {/* Image for md+ screens: absolutely positioned, for small screens: static below text */}
        </div>
      </Container>
      {/* Desktop image absolutely positioned outside container, only visible on md+ */}
      <div className='hidden md:block absolute top-0 bottom-0 right-0 w-1/2 overflow-hidden h-full'>
        <div className='w-full h-full relative'>
          <Image
            src='https://res.cloudinary.com/djowccubk/image/upload/v1747289276/images/Rock_Board_Dusk_Operations.webp'
            alt='Mining vehicle with backlit identification at dusk'
            fill
            sizes='(min-width: 768px) 50vw, 100vw'
            className='object-cover object-center'
            loading='lazy'
            quality={70}
          />
        </div>
      </div>
      <div className='w-full h-[300px] relative order-2 md:order-2 md:static md:h-auto my-4'>
        <div className='block md:hidden w-full h-full relative'>
          <Image
            src='https://res.cloudinary.com/djowccubk/image/upload/v1747289276/images/Rock_Board_Dusk_Operations.webp'
            alt='Mining vehicle with backlit identification at dusk'
            fill
            sizes='(max-width: 767px) 100vw'
            className='object-cover object-center'
            loading='lazy'
            quality={70}
          />
        </div>
      </div>
    </div>
  );
}
